import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from "./router";
import store from './store'
import moment from "moment";
import axios from "axios";
import {insertInstanceRules} from "./service/CsrfService";

Vue.config.productionTip = false

Vue.filter('formatDate', function (value) {
    if (!value) return '-'
    return moment(value).format("DD.MM.YYYY")
})

Vue.filter('formatDateTime', function (value) {
    if (!value) return '-'
    return moment(value).format("DD.MM.YYYY HH:MM")
})
axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
};
axios.defaults.withCredentials = true;
insertInstanceRules(axios);
Vue.filter('cleanString', function (string) {
    if (string) {
        string = string.charAt(0).toUpperCase() + string.slice(1)
        return string.replace('_', ' ')
    }
})

new Vue({
    store,
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
